export const ALLOY_THEME_ID = 'alloy';
export const WEAVE_THEME_ID = 'weave';
export const ALLOY_WEAVE_THEME_ID = 'alloy-weave';

export type ThemeId = 'alloy' | 'weave' | 'alloy-weave';
